$ = jQuery;
export const carousel = {
  mm: window.matchMedia("(max-width: 768px)"),
  init: function () {
    this.checkMatch(this.mm);
    this.mm.addListener(this.checkMatch);

    $(".events-carousel").owlCarousel({
      loop: false,
      nav: true,
      dots: false,
      items: 3,
      margin: 20,
      slideBy: 3,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        1000: {
          items: 3
        }
      },
    });

    $(".archipel-carousel-txt").owlCarousel({
      loop: false,
      nav: true,
      dots: false,
      items: 1,
      slideBy: 1
    });

  },
  checkMatch: function (x) {
    if (x.matches) {
      $(".grid-table").owlCarousel({
        loop: true,
        nav: true,
        dots: true,
        items: 1,
      });
    } else {
      $(".grid-table").owlCarousel("destroy");
    }
  },
};
